import React, {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import {EditLocalStoragePagesData} from "../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../Constants";
import MaterialReserveService from "../../API/orders/reservation/MaterialReserveService";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import ReservationMaterialEstimateUnitTable
    from "../../components/UI/table/warehouse/reservation/ReservationMaterialEstimateUnitTable";
import ModalAlert from "../../components/UI/table/customer-detales/ModalAlert";

const ReserveArrival = () => {
    const [alertData, setAlertData] = useState({});
    const [data, setData] = useState([]);
    const [change, setChange] = useState(false);
    const params = useParams();
    const {
        arrivalMaterialId,
        arrivalMaterial,
        currentCurrency,
        supplierId,
        warehouseId,
        id,
        baseUnit,
        typeMaterial
    } = params;
    const pathname = useLocation().pathname
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    const [unablePackaging, setUnablePackaging] = useState({});
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    useEffect(() => {
        getStartPageSize()
        MaterialReserveService.getAllByMaterialPriceUnitId(id).then(function (response) {
            const data = response.data;
            data.forEach((row) => {
                unablePackaging[row.id] = row.packaging;
            });
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: response.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [change]);

    const handleUnableCheckboxPackaging = (id, status) => {
        MaterialReserveService.setPackaging(id, status).then(function () {
            handleUnableTurn(id, status);
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    };

    const handleUnableTurn = (id, status) => {
        unablePackaging[id] = status
        setUnablePackaging(prevState => ({
            ...prevState,
            [id]: status
        }));
    };

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Резервы"}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Заявки на поставку", href: "/organization/materials-arrival"},
                    {
                        name: `Заявка на поставку ${arrivalMaterial}`,
                        href: `/organization/materials-price-unit-arrival/${arrivalMaterialId}/${arrivalMaterial}/${currentCurrency}/${supplierId}/${warehouseId}`
                    },
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Резервы
                    </Typography>
                </Box>
                <ReservationMaterialEstimateUnitTable
                    data={data}
                    setData={setData}
                    isButtonPurchase={false}
                    isSlab={false}
                    isColumnOrder={true}
                    unablePackaging={unablePackaging}
                    setUnablePackaging={handleUnableCheckboxPackaging}
                    handleModalAlert={handleModalAlert}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    isPieceMaterials={true}
                    isReserveArrival={true}
                    arrivalMaterialId={arrivalMaterialId}
                    arrivalMaterial={arrivalMaterial}
                    currentCurrency={currentCurrency}
                    supplierId={supplierId}
                    warehouseId={warehouseId}
                    id={id}
                    baseUnit={baseUnit}
                    typeMaterial={typeMaterial}
                />
            </Box>
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
        </Box>
    );
}
export default ReserveArrival